export class ApplyPaymentVo {
  /** courseEndMonth */
  courseEndMonth = ''

  /** courseStartMonth */
  courseStartMonth = ''

  /** detail */
  detail = undefined

  /** orderNo */
  orderNo = ''

  /** sign */
  sign = ''

  /** token */
  token = ''
}

export class BankDto {
  /** 银行名称 */
  bankName = ''

  /** 银行的英文缩写 */
  id = undefined
}

export class ChoosePaymethodVo {
  /** codeType */
  codeType = ''

  /** creditCardInfo */
  creditCardInfo = new CreditCardInfoVo()

  /** detail */
  detail = undefined

  /** installmentConfigItemId */
  installmentConfigItemId = undefined

  /** orderNo */
  orderNo = ''

  /** paymentChannelType */
  paymentChannelType = undefined

  /** paymentPlatformType */
  paymentPlatformType = undefined

  /** paymethodType */
  paymethodType = undefined

  /** prepaymentType */
  prepaymentType = undefined

  /** sign */
  sign = ''

  /** token */
  token = ''
}

export class ComplianceJoinResultDto {
  /** 是否为合规通道 */
  complianceChannel = false

  /** 商户是否可正常支付状态 */
  merchantPaymentState = false
}

export class CreditAmountDetailDto {
  /** 每期金额 */
  amount = undefined

  /** 手续费 */
  fee = undefined

  /** 分期项id */
  installmentConfigItemId = undefined

  /** 期数 */
  periods = undefined

  /** 贴息方式 */
  sellerPercent = undefined
}

export class CreditAmountDto {
  /** 分期详情 */
  list = []

  /** 最大限制金额，不包含自己 */
  maxPaymentAmount = undefined

  /** 最小限制金额 */
  minPaymentAmount = undefined

  /** 再次确认触发金额 */
  reConfirmLimitAmount = undefined

  /** 总金额 */
  totalAmount = undefined
}

export class CreditBankInfoBo {
  /** bankId */
  bankId = ''

  /** bankName */
  bankName = ''

  /** logo */
  logo = ''

  /** supportPeriods */
  supportPeriods = ''
}

export class CreditBanksBo {
  /** banks */
  banks = []

  /** creditBankType */
  creditBankType = 'ONE'

  /** periodConfig */
  periodConfig = []
}

export class CreditCardInfoVo {
  /** bankId */
  bankId = ''

  /** cardNo */
  cardNo = ''

  /** idNo */
  idNo = ''

  /** phone */
  phone = ''

  /** safetyCode */
  safetyCode = ''

  /** userName */
  userName = ''

  /** validDate */
  validDate = ''
}

export class EnumDto {
  /** desc */
  desc = ''

  /** index */
  index = undefined

  /** name */
  name = ''
}

export class FixedAmountQrcodeExpandDto {
  /** deleted */
  deleted = undefined

  /** expirationTime */
  expirationTime = ''

  /** extendInfoConfigs */
  extendInfoConfigs = ''

  /** fixAmount */
  fixAmount = undefined

  /** fixAmountDetail */
  fixAmountDetail = undefined

  /** id */
  id = undefined

  /** isInvalidation */
  isInvalidation = undefined

  /** merchantId */
  merchantId = undefined

  /** merchantQrcodeInfoId */
  merchantQrcodeInfoId = undefined

  /** paymentCode */
  paymentCode = ''

  /** remark */
  remark = ''
}

export class GetCashierUrlVo {
  /** data */
  data = ''

  /** thirdPartyAppId */
  thirdPartyAppId = ''

  /** userOpenId */
  userOpenId = ''
}

export class GetInstallmentRedpacketDto {
  /** amount */
  amount = undefined

  /** status */
  status = undefined
}

export class MerchantInfoByCodeDto {
  /** 优惠提示文案 */
  discountName = ''

  /** 商户号 */
  merchantNo = ''

  /** 备注是否必填 */
  remarkRequired = false

  /** 商户简称 */
  shopName = ''
}

export class MerchantQrCodePaymentVo {
  /** amount */
  amount = undefined

  /** codeType */
  codeType = ''

  /** extendRemarks */
  extendRemarks = []

  /** fixedAmountQrcode */
  fixedAmountQrcode = ''

  /** paymentCode */
  paymentCode = ''

  /** qrCodePaymentUrl */
  qrCodePaymentUrl = ''

  /** remark */
  remark = ''
}

export class MerchantTranExtendInfoDto {
  /** 是否多选 */
  isMultiply = false

  /** 是否展示 */
  isShow = false

  /** 标签名称 */
  labelName = ''

  /** 最大长度 */
  maxLength = undefined

  /** 标签id */
  merchantLabelId = undefined

  /** 商户标签类型 1文本 2下拉框 */
  merchantLabelType = undefined

  /** 配置属性对象 */
  optionConfigs = []

  /** 占位符 */
  placeHolder = ''

  /** 自定义属性id */
  presetAttributeId = undefined

  /** 是否必填 */
  required = false

  /** 正则表达式 */
  rule = ''
}

export class MonthPayCheckBo {
  /** 是否可以使用月月付 */
  canUse = false

  /** 当不可使用的时候，错误消息 */
  message = ''
}

export class OptionConfigsDto {
  /** 标签id */
  merchantLabelListId = undefined

  /** 标签名称 */
  optionName = ''
}

export class PayConfirmDto {
  /** callbackUrl */
  callbackUrl = ''

  /** description */
  description = ''

  /** errorMessage */
  errorMessage = ''

  /** payFailCallbackUrl */
  payFailCallbackUrl = ''

  /** status */
  status = false
}

export class PayConfirmVo {
  /** detail */
  detail = undefined

  /** orderNo */
  orderNo = ''

  /** sign */
  sign = ''

  /** token */
  token = ''

  /** verifyCode */
  verifyCode = ''
}

export class PayMethodInfoDto {
  /** canCustomerUse */
  canCustomerUse = undefined

  /** merchantPaymentMethodState */
  merchantPaymentMethodState = undefined

  /** payMethodType */
  payMethodType = undefined

  /** paymentChannelOrder */
  paymentChannelOrder = undefined

  /** paymentChannelType */
  paymentChannelType = undefined

  /** paymentMethodName */
  paymentMethodName = ''

  /** paymentPlatformType */
  paymentPlatformType = undefined

  /** prepaymentType */
  prepaymentType = undefined
}

export class PayQueryVo {
  /** detail */
  detail = undefined

  /** orderNo */
  orderNo = ''

  /** sign */
  sign = ''

  /** token */
  token = ''
}

export class PaySendSmsDto {
  /** errorMessage */
  errorMessage = ''

  /** status */
  status = false
}

export class PaymentMethodListDto {
  /** amount */
  amount = undefined

  /** payMethodInfos */
  payMethodInfos = []
}

export class PaymentResultDto {
  /** 每期金额 */
  amount = ''

  /** 手续费 */
  fee = ''

  /** 花呗平台类型 */
  huabeiPlatformType = undefined

  /** 原始手续费 */
  originFee = ''

  /** 支付方式 */
  payMethodType = undefined

  /** 支付渠道类型 */
  paymentChannelType = undefined

  /** 支付方式交易号尾号 */
  paymentMethodTradeTailNo = ''

  /** 付款时间 */
  paymentTime = ''

  /** 分期期数 */
  periods = undefined

  /** 实际支付金额 */
  realPayAmount = ''

  /** 备注信息 */
  remark = ''

  /** 商户标签属性 */
  remarkLabels = []

  /** 随机立减的减免金额，单位：元 */
  rewardAmount = ''

  /** scp交易号 */
  schoolPalCloudPayTradeNo = ''

  /** 贴息方式 */
  sellerPercent = undefined

  /** 商户简称 */
  shopName = ''

  /** 交易状态 */
  transactionState = undefined
}

export class PaymentResultResponseDto {
  /** merchantNo */
  merchantNo = ''

  /** merchantTradeNo */
  merchantTradeNo = ''

  /** payMethodType */
  payMethodType = undefined

  /** paymentMethodTradeNo */
  paymentMethodTradeNo = ''

  /** sign */
  sign = ''

  /** simplePaymentMethodTradeNo */
  simplePaymentMethodTradeNo = ''

  /** timestamp */
  timestamp = ''

  /** transactionId */
  transactionId = undefined
}

export class PaymentUserResultDto {
  /** 轮询支付结果接口参数ResponseDto */
  paymentResult = new PaymentResultResponseDto()

  /** 付款时间 */
  paymentTime = ''

  /** 付款金额 */
  realPayAmount = ''
}

export class PeriodBo {
  /** fee */
  fee = undefined

  /** period */
  period = undefined
}

export class PreOrderDto {
  /** codeType */
  codeType = ''

  /** detail */
  detail = undefined

  /** discountName */
  discountName = ''

  /** merchantNo */
  merchantNo = ''

  /** orderNo */
  orderNo = ''

  /** paymentSource */
  paymentSource = ''

  /** sign */
  sign = ''

  /** token */
  token = ''
}

export class PrepaymentInfoDto {
  /** callbackUrl */
  callbackUrl = ''

  /** payFailCallbackUrl */
  payFailCallbackUrl = ''

  /** payInfo */
  payInfo = ''
}

export class RemarkLabelsDto {
  /** configKey */
  configKey = ''

  /** configValue */
  configValue = ''
}

export class SendSmsVo {
  /** creditCardInfo */
  creditCardInfo = new CreditCardInfoVo()

  /** detail */
  detail = undefined

  /** orderNo */
  orderNo = ''

  /** sign */
  sign = ''

  /** token */
  token = ''
}

export class SimpleResponse {
  /** data */
  data = new ComplianceJoinResultDto()

  /** errorCode */
  errorCode = undefined

  /** errorMessage */
  errorMessage = ''

  /** status */
  status = false
}

export class TransactionExtendRemarkInfoBo {
  /** merchantLabelId */
  merchantLabelId = undefined

  /** merchantLabelListId */
  merchantLabelListId = undefined

  /** value */
  value = ''
}

export class UmfPayQueryBo {
  /** errorMessage */
  errorMessage = ''

  /** status */
  status = undefined
}
